export default __webpack_public_path__ + "static/media/D_05_04_bg.06a5a75c.mp4";